module.exports = __webpack_public_path__ + "img/qa6.9975bd82.jpg";